import "./styles.css";

import { CreateFlow } from "./CreateFlow";
import { TestFlow } from "./testFlow"

export default function App() {
  return (
    <>
      <CreateFlow />
    </>
  );
}